/**
 * @file Re-exports the modal that lets a Backstage user jump to an investment.
 */
import GoToInvestmentModal from "./GoToInvestmentModal";

export default GoToInvestmentModal;
